import { Tag } from 'antd'

import { QuestionnaireState } from 'src/api/requests'
import { useLocales } from 'src/locales'

type Props = {
  status?: QuestionnaireState
}

const QuestionnairesStatusMap = {
  [QuestionnaireState.DRAFT]: '',
  [QuestionnaireState.ACTIVE]: 'success',
  [QuestionnaireState.INACTIVE]: 'warning'
}

export const QuestionnairesStatusTag = ({ status }: Props) => {
  const { t } = useLocales()

  if (!status) return '-'

  const color = QuestionnairesStatusMap[status]

  return <Tag color={color}>{t(`questionnaires.${status}`)}</Tag>
}
